import { getToken } from "./authHeaderService";
import { apiInstance } from "./axiosService";
import { convertObjToQueryParams } from "./commonHelper";

export const getProducts = async (payload = {}) => {
    let res = await apiInstance.get("products/getProducts" + convertObjToQueryParams(payload), { headers: getToken() });
    return res;
};

export const createProduct = (payload) => {
    return apiInstance.post("products/createProduct", payload, { headers: getToken() });
};

export const deleteProductById = (payload) => {
    return apiInstance.delete(`products/deleteProductById/${payload?.id}`, { headers: getToken() });
};

export const getProductBenefitsById = async (payload) => {
    let res = await apiInstance.get("products/getProductById" + convertObjToQueryParams(payload), { headers: getToken() });
    let data = { data: { records: res?.data?.benifits, totalRecords: res?.data?.benifits?.length }, ok: res?.ok }
    return data;
};

export const getProductInstructionsById = async (payload) => {
    let res = await apiInstance.get("products/getProductById" + convertObjToQueryParams(payload), { headers: getToken() });
    let data = { data: { records: res?.data?.instruction, totalRecords: res?.data?.instruction?.length }, ok: res?.ok }
    return data;
};

export const getProductGalleryById = async (payload) => {
    let res = await apiInstance.get("products/getProductById" + convertObjToQueryParams(payload), { headers: getToken() });
    let data = { data: { records: res?.data?.gallery, totalRecords: res?.data?.gallery?.length }, ok: res?.ok }
    return data;
};

export const createProductBenifits = (payload) => {
    return apiInstance.post("products/createProductBenifits", payload, { headers: getToken() });
};

export const deleteProductBenefitById = (payload) => {
    return apiInstance.delete(`products/deleteProductBenefitById/${payload?.id}`, { headers: getToken() });
};

export const createProductInstruction = (payload) => {
    return apiInstance.post("products/createProductInstruction", payload, { headers: getToken() });
};

export const deleteProductInstructionById = (payload) => {
    return apiInstance.delete(`products/deleteProductInstructionById/${payload?.id}`, { headers: getToken() });
};

export const deleteProductGaleryById = (payload) => {
    return apiInstance.delete(`products/deleteProductGaleryById/${payload?.id}`, { headers: getToken() });
};

export const createProductGallery = (payload) => {
    return apiInstance.post("products/createProductGallery", payload, { headers: getToken() });
};

export const getUserProductByUserId = (payload) => {
    let res = apiInstance.get("products/getUserProductByUserId" + convertObjToQueryParams(payload), { headers: getToken() });
    return res;
};

export const createUserOrderCms = (payload) => {
    return apiInstance.post("products/createUserOrderCms", payload, { headers: getToken() });
};

